// eslint-disable-next-line import/prefer-default-export
export const MESSAGE_MODAL_SX = {
  '& .MuiPaper-root': {
    width: '600px',
    maxWidth: '90vw',
    borderRadius: '32px',
    padding: '48px 40px 40px',
  },
};
